<template lang='pug'>
v-container.mt-3
  v-row
    v-col(cols='12')
      .mb-2.d-flex.justify-space-between.align-center
        h4 3Dアセット一覧

        v-spacer
        v-spacer

        v-text-field.me-4(
          rounded
          v-model="search"
          label="3Dアセットを検索"
          clearable
          hide-details
          single-line
          variant="outlined"
          density="compact"
          prepend-inner-icon="mdi-magnify"
          width="10%"
        )
        v-btn(@click='openNewAssetFileDialog' prepend-icon='mdi-file-plus' color="primary" dark) 新しい3Dアセットを追加
        v-dialog.assets-dialog(v-model="dialog" persistent max-width="800px")
          v-card
            v-card-title {{ isDialogEdit ? '3Dアセットを編集' : '3Dアセットを追加' }}
            v-card-text
              v-form(ref='form')
                v-text-field.mb-2(
                  v-model='assetFileName',
                  label='登録名(必須)',
                  :rules='[v => !!v || "ファイル名を入力してください"]',
                  required
                )

                v-file-input.mb-2(
                  v-model='modelFile',
                  :label='isDialogEdit ? "更新用3Dアセット(任意)" : "3Dアセット(必須)"',
                  accept='.obj, .fbx, ifc, .gltf, .glb',
                  :rules='isDialogEdit ? [] : [v => !!v || "3Dファイルを選択してください"]'
                )

                v-file-input.mb-2(
                  v-model='thumbnailImagefile',
                  :label='isDialogEdit ? "更新用サムネイル画像(任意)" : "サムネイル画像(任意)"',
                  accept='jpg, jpeg, png, gif',
                )
                .mb-3(v-if='thumbnailImagePreview')
                  h5.mb-3 サムネイル画像のプレビュー
                  v-img(:src='thumbnailImagePreview' max-width='40' max-height='40')

                v-select.mb-2(
                  attach
                  v-model='selectedCategory',
                  :items='categories',
                  :menu-props='{ attach: ".assets-dialog"}',
                  item-title='name',
                  item-value='id',
                  label='カテゴリー(任意)',
                )

                v-alert(v-if='uploadResult.type' :type='uploadResult.type' closable variant='tonal') {{ uploadResult.message }}
            v-card-actions
              v-btn(color="grey" text @click="dialog = false") 閉じる
              v-spacer
              v-btn.me-3(variant="tonal" color='primary' prepend-icon='mdi-upload' :loading='uploading' @click="uploadAssetFile") {{ isDialogEdit ? '3Dアセットを更新' : '3Dアセットを登録' }}

      v-data-table(
        v-if="assetFiles"
        :items="assetFiles"
        :items-per-page="100"
        :search="search"
        item-key="id"
        :headers=`[
          { align: 'start', title: 'ID', key: 'id' },
          { align: 'start', title: 'サムネイル', key: 'thumbnail', sortable: false },
          { align: 'start', title: '登録名', key: 'name' },
          { align: 'start', title: 'カテゴリー', key: 'category_name' },
          { align: 'start', title: '登録日', key: 'created_at' },
          { align: 'start', title: '更新日', key: 'updated_at' },
          { align: 'start', title: 'ファイル容量', key: 'file_size' },
          { align: 'center', title: '操作', key: 'actions', sortable: false }
        ]`
      )
        template(v-slot:item.thumbnail="{ item }")
          v-img(v-if="item.thumbnail_url" :src="item.thumbnail_url" max-width="40" max-height="40")
        template(v-slot:item.category="{ item }")
          span(v-if="item.category") {{ item.category.name }}
        template(v-slot:item.created_at="{ item }")
          span {{ new Date(item.created_at).toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}
        template(v-slot:item.updated_at="{ item }")
          span {{ new Date(item.updated_at).toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}
        template(v-slot:item.actions="{ item }")
          v-btn(@click="openEditAssetDialog(item)" icon='mdi-square-edit-outline' variant='plain' color='primary')
          v-btn(@click="deleteAssetFile(item)" icon='mdi-delete' variant='plain' color='error')
</template>
<script setup>
import axios from 'axios'
import { ref, reactive, watch, defineProps } from 'vue'

import showToast from '../shared/show_toast'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
}

const props = defineProps([
  'assetFiles',
  'assetFilesBaseUrl',
  'categories'
])
const assetFiles = reactive(JSON.parse(props.assetFiles))
const categories = reactive(JSON.parse(props.categories))

const form = ref(null)
const uploading = ref(false)
const uploadResult = reactive({
  type: null,
  message: ''
})

const search = ref('')
const dialog = ref(false)
const isDialogEdit = ref(false)
const assetFileId = ref(null)

const assetFileName = ref('')
const modelFile = ref(null)
const thumbnailImagefile = ref(null)
const thumbnailImagePreview = ref(null)
watch(thumbnailImagefile, (newFile) => {
  if (newFile) {
    thumbnailImagePreview.value = URL.createObjectURL(newFile)
  } else {
    thumbnailImagePreview.value = null
  }
})

const selectedCategory = ref(null)

const openNewAssetFileDialog = () => {
  assetFileId.value = null
  assetFileName.value = ''
  modelFile.value = null
  thumbnailImagefile.value = null
  thumbnailImagePreview.value = null
  selectedCategory.value = null
  uploadResult.type = null
  uploadResult.message = ''

  isDialogEdit.value = false
  dialog.value = true
}

const openEditAssetDialog = (asset_file) => {
  assetFileId.value = asset_file.id
  assetFileName.value = asset_file.name
  modelFile.value = null
  thumbnailImagefile.value = null
  thumbnailImagePreview.value = null
  selectedCategory.value = asset_file.category_id
  uploadResult.type = null
  uploadResult.message = ''

  isDialogEdit.value = true
  dialog.value = true
}

const deleteAssetFile = (asset_file) => {
  if (confirm(`「${asset_file.name}」を削除しますか？`)) {
    const formData = new FormData()
    formData.append('id', asset_file.id)
    formData.forEach((value, key) => {
      console.log(key, value)
    })

    axios.delete(`${props.assetFilesBaseUrl}/delete_asset_file`, { data: formData }).then(res => {
      if (res.status === 200) {
        const targetAssetFileIndex = assetFiles.findIndex(assetFile => assetFile.id === asset_file.id)
        if (targetAssetFileIndex !== -1) {
          assetFiles.splice(targetAssetFileIndex, 1)
        }
        showToast(res.data.message)
      }
    }).catch(error => {
      showToast(error?.response?.data?.error, 'error')
      console.error('Delete asset file failed:', error)
    })
  }
}

const uploadAssetFile = async () => {
  if((await form.value.validate()).valid) {
    uploading.value = true

    const formData = new FormData()
    if(isDialogEdit.value) {
      formData.append('id', assetFileId.value)
    }
    formData.append('name', assetFileName.value)
    if(modelFile.value) {
      formData.append('origin_file', modelFile.value)
    }
    if(thumbnailImagefile.value) {
      formData.append('thumbnail', thumbnailImagefile.value)
    }
    if(selectedCategory.value) {
      formData.append('category_id', selectedCategory.value)
    }

    try {
      const res = await axios.post(`${props.assetFilesBaseUrl}/upload_asset_file`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      uploading.value = false
      if (res.status === 200 && !res.data.errors?.length) {
        if (isDialogEdit.value) {
          // NOTE: 更新時 --------
          const targetAssetFileIndex = assetFiles.findIndex(assetFile => assetFile.id === assetFileId.value)
          if (targetAssetFileIndex !== -1) {
            assetFiles[targetAssetFileIndex] = res.data.asset_file
          }
        }
        else {
          assetFiles.push(res.data.asset_file)

          assetFileName.value = ''
          modelFile.value = null
          thumbnailImagefile.value = null
          thumbnailImagePreview.value = null
          selectedCategory.value = null
          await form.value.reset()
        }

        uploadResult.type = 'success'
        uploadResult.message = `「${res.data.asset_file.name}」の${isDialogEdit.value ? '更新' : '登録'}に成功しました`
      } else {
        uploadResult.type = 'error'
        uploadResult.message = res.data.errors.join(', ')
      }
    } catch (error) {
      console.error('Upload asset file failed:', error)
      uploadResult.type = 'error'
      uploadResult.message = error
      uploading.value = false
    }
  }
}
</script>
